if (!customElements.get('rw-battle-archives')) {
  customElements.define('rw-battle-archives', class extends HTMLElement {
    connectedCallback() {
      if (this.initialized) return;
      this.initialized = true;
      this.initializePhotoViewer();
      const select = this.querySelector('select');
      if (!select) return;
      const grid = this.querySelector('.rw-archive-grid');
      const items = [...this.querySelectorAll('.rw-archive-item')];
      if (this.hasAttribute('data-records')) {
        items.sort((a, b) => Number(a.dataset.order) - Number(b.dataset.order) || a.dataset.entry.localeCompare(b.dataset.entry));
        items.forEach(item => grid.append(item));
      }
      const usedCategories = new Set(items.map(item => item.dataset.category));
      [...select.options].forEach(option => { if (option.value !== 'all' && !usedCategories.has(option.value)) option.remove(); });
      if (usedCategories.size > 1) this.querySelector('.rw-archive-filter').hidden = false;
      const more = this.querySelector('.rw-archive-more');
      const pageSize = Number(this.dataset.pageSize) || items.length;
      let shown = pageSize;
      const update = () => {
        let matches = 0;
        let visible = 0;
        items.forEach(item => {
          const matchesCategory = select.value === 'all' || item.dataset.category === select.value;
          if (matchesCategory) matches += 1;
          item.hidden = !matchesCategory || matches > shown;
          if (item.hidden) item.querySelectorAll('video').forEach(video => video.pause());
          else visible += 1;
        });
        more.hidden = visible >= matches;
        this.querySelector('[role="status"]').textContent = `${visible} of ${matches} archive items shown.`;
      };
      select.addEventListener('change', () => { shown = pageSize; update(); });
      more.addEventListener('click', () => {
        const firstHidden = items.find(item => item.hidden && (select.value === 'all' || item.dataset.category === select.value));
        shown += pageSize;
        update();
        firstHidden?.querySelector('a, video')?.focus();
      });
      update();
      this.closest('.shopify-section')?.addEventListener('shopify:block:select', event => {
        const item = event.target.closest('.rw-archive-item');
        if (!item || !item.hidden) return;
        select.value = 'all';
        select.dispatchEvent(new Event('change'));
      });
    }

    initializePhotoViewer() {
      const dialog = this.querySelector('.rw-archive-dialog');
      if (!dialog || typeof dialog.showModal !== 'function') return;
      const image = dialog.querySelector('.rw-archive-enlarged');
      const caption = dialog.querySelector('[data-archive-caption]');
      const previous = dialog.querySelector('[data-archive-previous]');
      const next = dialog.querySelector('[data-archive-next]');
      let trigger;
      let photos = [];
      let index = 0;
      const show = position => {
        index = (position + photos.length) % photos.length;
        const photo = photos[index];
        image.src = photo.href;
        image.alt = photo.querySelector('img')?.alt || 'Rave Wars event experience';
        caption.textContent = photo.dataset.photoCaption || image.alt;
        previous.hidden = next.hidden = photos.length < 2;
      };
      this.querySelectorAll('[data-archive-photo]').forEach(photo => {
        photo.setAttribute('aria-haspopup', 'dialog');
        photo.setAttribute('aria-label', `Enlarge photo: ${photo.querySelector('img')?.alt || 'Rave Wars event experience'}`);
        photo.addEventListener('click', event => {
          if (event.button !== 0 || event.ctrlKey || event.metaKey || event.shiftKey || event.altKey) return;
          event.preventDefault();
          photos = [...this.querySelectorAll('[data-archive-photo]')].filter(link => !link.closest('.rw-archive-item').hidden);
          trigger = photo;
          show(photos.indexOf(photo));
          dialog.showModal();
        });
      });
      dialog.querySelector('[data-archive-close]').addEventListener('click', () => dialog.close());
      previous.addEventListener('click', () => show(index - 1));
      next.addEventListener('click', () => show(index + 1));
      dialog.addEventListener('keydown', event => {
        if (event.key === 'ArrowLeft' || event.key === 'ArrowRight') {
          event.preventDefault();
          show(index + (event.key === 'ArrowRight' ? 1 : -1));
        }
      });
      dialog.addEventListener('click', event => { if (event.target === dialog) dialog.close(); });
      dialog.addEventListener('close', () => {
        image.removeAttribute('src');
        trigger?.focus();
      });
    }
  });
}
